import {
    GENDER_LIST_REQUEST,
    GENDER_LIST_SUCCESS,
    GENDER_LIST_FAIL
} from '../constants/genderConstants'

export const genderListReducer = (state = {}, action) => {
    switch (action.type) {
        case GENDER_LIST_REQUEST:
            return { loading: true }
        case GENDER_LIST_SUCCESS:
            return { loading: false, genders: action.payload }
        case GENDER_LIST_FAIL:
            return { loading: false, error: action.payload }
        default:
            return state
    }
}

